import milipol2022 from './Images/blog/2022-forensics-blog.jpg'
import tupEagles from './Images/blog/tup-eagles-blog.jpg'
import forensics2022 from './Images/blog/forensics-blog.jpg'
import switch2022 from './Images/blog/switch-blog.jpg'


const blogPosts = {
    'forensics2022': {
        'thumbnailTitle': 'NAFSLE 2022',
        'title': 'National Forensic Science Symposium for Law Enforcement 2022',
        'image': forensics2022,
        'content': <p>
            Another exciting post to wrap up this hectic week for ANOR! Our pleasure to be 
            invited for the National Science Symposium for Law Enforcement (NAFSLE) 
            from 26th to 28th October, which organized by Royal Malaysia Police.<br /><br />  
            The agenda of this symposium is to address the challenge in forensic science 
            in investigating and to promote the evolution and innovation of the forensic science. 
            We are given the opportunity to exhibit range of spectroscopy products 
            and services that could help to meet the challenge of narcotics detection and identification.
            <br /><br /> Many of the visitors were intrigued by our Senstrio Cloud services, 
            they’ve never thought that narcotics tracing can be so easy, seamless and efficient. 
            <br /><br />One of the senior police officer mentioned that Senstrio Cloud services could be a 
            great asset in combating the rising threat of NPS. <br /><br /> He said, 
            “The number of NPS type has been increasing rapidly within the past few years. 
            In order to combat this, we need something that can keep on learning about the 
            new drug available in the market and constantly update its database. Not just being that, 
            the digital connected service provided by Senstrio allows data sharing among the organization 
            which helps us to identify new drug faster than before.”
        </p>
    },

    'tupaward': {
        'thumbnailTitle': 'T-Up Award',
        'title': 'T-Up Excellence Award',
        'image': tupEagles,
        'content': <p>
            Congrats to Phua Wei Ji for receiving the T-Up Eagles Award today! <br /><br />
            Through our T-Up with A*STAR – Agency for Science, Technology and Research, and 
            Singapore Institute of Technology‘s Integrated Work Study Programme (IWSP) Wei Ji 
            and his T-Up mentor Dr Yee-Fun Lim from Institute of Materials Research and Engineering 
            (IMRE) developed the ANOR Data Analyzer (ADA) application hosted on ANOR’s spectrometer
            device. It allows the quick collection and identification of drug components and chemicals 
            through its spectral fingerprints. Above all outcomes, we have successfully launched our 
            Senstrio product, which is a Spectroscopy as a Service platform.<br /><br /> 
            In addition, we are truly honoured that Dr Tan See Leng, Minister for Manpower and 
            Second Minister for Trade and Industry specially mentioned Phua Wei Ji from Enterprise Singapore, 
            and Singapore Institute of Technology for their unwavering support. ANOR Technologies will continue to 
            collaborate with our partners and advocate for nurturing young talents for the deep tech start-up ecosystem.
        </p>
    },

    'switch2022': {
        'thumbnailTitle': 'SWITCH 2022',
        'title': 'SWITCH 2022',
        'image': switch2022,
        'content': <p>
            The first two days of Singapore Week of Innovation and Technology (SWITCH) 2022 was a blast! 
            Team ANOR got the chance to make new connections with many visitors, both locally and internationally! 
            It was a great avenue for ANOR Technologies to increase exposure through networking. We introduced Senstrio Cloud 
            as part of ANOR’s spectroscopy services. Senstrio Cloud integrate Artificial Intelligence (AI) and 
            spectroscopy technology to provide a suite of cloud-based solutions, enabling on-site sample testing for easy analysis. <br /><br />
            ANOR Technologies takes terahertz spectroscopy to the next level by integrating hardware and software to provide 
            a seamless connection, letting users to truly sense beyond the 
        </p>
    },

    'milipol2022': {
        'thumbnailTitle': 'Milipol 2022',
        'title': 'Milipol 2022',
        'image': milipol2022,
        'content': <p>
            Team ANOR’s first Milipol event was a blast! We are grateful for the opportunity to demonstrate the capabilities of our Terahertz spectroscopy 
            technology for drug and explosive detection and to receive such encouraging responses. <br /><br />
            This is a milestone to strengthen our presence in Asia Pacific from the engagement we had with visitors and d
            elegates belonging to many fields of expertise. <br /><br />To advance ANOR into the deep-tech sector, we’ve taken in a lot of favorable feedback 
            and focus on our proprietary technology. <br /><br /> Anor is committed to be the cutting-edge provider of Terahertz sensing solutions to combat 
            security threats to public safety.
        </p>
    }
    
}

export default blogPosts